import {push} from "connected-react-router";

const showScreen= (route) => async (dispatch) =>
{
    dispatch(push(route));
};
export default showScreen;